const MAP = {
  draft: "border-border text-muted-foreground",
  open: "bg-[hsl(var(--warning))] text-black border-[hsl(var(--warning))]",
  offered: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  published: "bg-foreground text-background border-foreground",
  accepted: "bg-foreground text-background border-foreground",
  in_progress: "bg-[hsl(var(--success))] text-black border-[hsl(var(--success))]",
  on_site: "bg-[hsl(var(--success))] text-black border-[hsl(var(--success))]",
  completed: "bg-[hsl(var(--success))]/20 text-foreground border-[hsl(var(--success))]",
  missed: "bg-[hsl(var(--alert))] text-white border-[hsl(var(--alert))]",
  late: "bg-[hsl(var(--alert))]/15 text-foreground border-[hsl(var(--alert))]",
  called_off: "bg-[hsl(var(--alert))]/15 text-foreground border-[hsl(var(--alert))]",
  submitted: "border-border text-muted-foreground",
  under_review: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  clarification: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  approved: "bg-[hsl(var(--success))]/20 text-foreground border-[hsl(var(--success))]",
  closed: "bg-secondary text-secondary-foreground border-border",
  locked: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  exported: "bg-foreground text-background border-foreground",
  delivered: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  paid: "bg-[hsl(var(--success))]/20 text-foreground border-[hsl(var(--success))]",
  partially_paid: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  active: "bg-[hsl(var(--success))]/20 text-foreground border-[hsl(var(--success))]",
  pending: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  rejected: "bg-[hsl(var(--alert))]/15 text-foreground border-[hsl(var(--alert))]",
  low: "border-border text-muted-foreground",
  medium: "bg-[hsl(var(--warning))]/20 text-foreground border-[hsl(var(--warning))]",
  high: "bg-[hsl(var(--alert))]/15 text-foreground border-[hsl(var(--alert))]",
  critical: "bg-[hsl(var(--alert))] text-white border-[hsl(var(--alert))]",
  ok: "bg-[hsl(var(--success))]/20 text-foreground border-[hsl(var(--success))]",
  out_of_geofence: "bg-[hsl(var(--alert))] text-white border-[hsl(var(--alert))]",
  unknown: "border-border text-muted-foreground",
};

// `label` overrides the TEXT while `value` still picks the colour, for the cases
// where the word a user needs is not the key the palette is indexed on -- a
// deleted account is styled like `missed` and must not be captioned "MISSED".
// Without it the caller silently renders the wrong word, which is worse than no
// prop at all because the badge still looks deliberate.
export function StatusBadge({ value, testid, label }) {
  if (value === null || value === undefined || value === "") return <span className="text-muted-foreground">—</span>;
  const cls = MAP[value] || "border-border text-muted-foreground";
  return (
    <span data-testid={testid} className={`inline-block border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wider ${cls}`}>
      {label || String(value).replace(/_/g, " ")}
    </span>
  );
}
